import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RequireAdmin = ({ children }) => {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const role = (localStorage.getItem('role') || '').toLowerCase();

  if (!isLoggedIn || role !== 'admin') {
    return <Navigate to="/adminlogin" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default RequireAdmin;
